import { createSlice } from '@reduxjs/toolkit'
import { getIncomes, saveIncome, createIncome, deleteIncome } from './incomeActions'

const initialState = {
  incomes: [],
  loading: false,
  error: false,
  loadingError: false,
  savingError: false,
  saving: false,
  saved: false,
  savedIncome: {},
  deleting: false,
  deleted: false,
  deletingError: false,
}

function isRejectedAction(action) {
  return action.type.endsWith('rejected')
}

const incomesSlice = createSlice({
  name: 'incomes',
  initialState,
  reducers: {
    clear: (state) => {
      state.saved = false
      state.savingError = false
      state.loadingError = false
      state.savedIncome = {}
      state.deleting = false
      state.deleted = false
      state.deletingError = false
    },
  },

  extraReducers: (builder) => {
    // Add reducers for additional action types here, and handle loading state as needed
    builder
      .addCase(getIncomes.fulfilled, (state, { payload }) => {
        state.loading = false
        state.incomes = payload
      })
      .addCase(getIncomes.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(saveIncome.pending, (state) => {
        state.saving = true
        state.savingError = null
        state.saved = false
      })
      .addCase(saveIncome.fulfilled, (state, { payload }) => {
        state.savingError = null
        state.incomes[state.incomes.findIndex((p) => p.id === payload.id)] = payload
        state.savedIncome = payload
        state.saved = true
        state.saving = false
      })
      .addCase(saveIncome.rejected, (state, { payload }) => {
        state.saving = false
        state.savingError = payload
        state.saved = false
      })
      .addCase(createIncome.pending, (state) => {
        state.saving = true
        state.savingError = null
        state.saved = false
      })
      .addCase(createIncome.fulfilled, (state, { payload }) => {
        state.savingError = null
        state.savedIncome = payload
        state.saved = true
        state.saving = false
      })
      .addCase(createIncome.rejected, (state, { payload }) => {
        state.saving = false
        state.savingError = payload
        state.saved = false
      })
      .addCase(deleteIncome.pending, (state) => {
        state.deleting = true
        state.deletingError = null
        state.deleted = false
      })
      .addCase(deleteIncome.fulfilled, (state) => {
        state.deletingError = null
        state.deleted = true
        state.deleting = false
      })
      .addCase(deleteIncome.rejected, (state, { payload }) => {
        state.deleting = false
        state.deletingError = payload
        state.deleted = false
      })
      .addMatcher(
        isRejectedAction,
        // `action` will be inferred as a RejectedAction due to isRejectedAction being defined as a type guard
        (state, { payload }) => {
          state.loading = false
          state.error = payload
        },
      )
  },
})

export const { clear } = incomesSlice.actions
export default incomesSlice.reducer
